import { render, staticRenderFns } from "./ServiceLimitations.vue?vue&type=template&id=5704ddb8&scoped=true&"
import script from "./ServiceLimitations.vue?vue&type=script&lang=js&"
export * from "./ServiceLimitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5704ddb8",
  null
  
)

export default component.exports